import { lazy } from "react";
import { KycAdminPaths } from "./KYCAdminPaths";

export const kycAdminRoutes = [
  // Search AB Details
  {
    path: KycAdminPaths.searchByBankAccountNumber,
    ComponentIn: lazy(() => import("Components/KycAdmin/SearchABDetails/BankAccountNumber"))
  },
  {
    path: KycAdminPaths.searchByRegisteredMobileNo,
    ComponentIn: lazy(() => import("Components/KycAdmin/SearchABDetails/RegisteredMobileNumber"))
  },
  {
    path: KycAdminPaths.displayWall,
    ComponentIn: lazy(() => import("Components/KycAdmin/SearchABDetails/DisplayWall"))
  },
  {
    path: KycAdminPaths.searchByAadharNo,
    ComponentIn: lazy(() => import("Components/KycAdmin/SearchABDetails/AadharNumber"))
  },
  {
    path: KycAdminPaths.searchByPanNo,
    ComponentIn: lazy(() => import("Components/KycAdmin/SearchABDetails/PanNumber"))
  },
  {
    path: KycAdminPaths.stateWiseSearchAbName,
    ComponentIn: lazy(() => import("Components/KycAdmin/SearchABDetails/StateWiseSearchAbName.jsx"))
  },
  {
    path: KycAdminPaths.referenceNumber,
    ComponentIn: lazy(() => import("Components/KycAdmin/SearchABDetails/ReferenceNumber.jsx"))
  },
  {
    path: KycAdminPaths.searchByEmailId,
    ComponentIn: lazy(() => import("Components/KycAdmin/SearchABDetails/EmailId.jsx"))
  },
  {
    path: KycAdminPaths.mobileDeclaration,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Declaration/MobileDeclaration/MobileDeclaration.js")
    )
  },
  {
    path: KycAdminPaths.infoUpdate,
    ComponentIn: lazy(() => import("Components/KycAdmin/Declaration/InfoUpdate/InfoUpdate.jsx"))
  },
  {
    path: KycAdminPaths.terminateOk,
    ComponentIn: lazy(() => import("Components/KycAdmin/Terminate/TerminateOk.js"))
  },
  {
    path: KycAdminPaths.terminateAB,
    ComponentIn: lazy(() => import("Components/KycAdmin/Terminate/TerminateAb/TerminateAb.js"))
  },
  {
    path: KycAdminPaths.softTerminate,
    ComponentIn: lazy(() => import("Components/KycAdmin/Terminate/SoftTerminate/SoftTerminate.jsx"))
  },
  // Delete AB Details
  {
    path: KycAdminPaths.deleteBankAccountDetails,
    ComponentIn: lazy(() => import("Components/KycAdmin/DeleteABDetails/DeleteBankAccount"))
  },
  {
    path: KycAdminPaths.deletePanNumber,
    ComponentIn: lazy(() => import("Components/KycAdmin/DeleteABDetails/DeletePanNumber"))
  },
  {
    path: KycAdminPaths.enableReKYC,
    ComponentIn: lazy(() => import("Components/KycAdmin/DeleteABDetails/EnableReKYC"))
  },
  {
    path: KycAdminPaths.disableBankNo,
    ComponentIn: lazy(() => import("Components/KycAdmin/DisableAbDetails/ABBankNo"))
  },
  {
    path: KycAdminPaths.disablePanNo,
    ComponentIn: lazy(() => import("Components/KycAdmin/DisableAbDetails/ABPanNo"))
  },

  {
    path: KycAdminPaths.checkMonthlyMeeting,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/AssociateBuyers/MonthlyMeetings/ABCheckMonthlyMeetings")
    )
  },
  {
    path: KycAdminPaths.abUnstop,
    ComponentIn: lazy(() => import("Components/kycAdminV2/ABIdUnStop/ABIdUnStop"))
  },
  {
    path: KycAdminPaths.kycReportsViewLogs,
    ComponentIn: lazy(() => import("Components/kycAdminV2/KYCReportsViewLogs/KYCReportsViewLogs"))
  },
  {
    path: KycAdminPaths.increaseMobileCount,
    ComponentIn: lazy(
      () => import("Components/kycAdminV2/IncreaseMobileCount/IncreaseMobileCount.jsx")
    )
  },
  {
    path: KycAdminPaths.exceptionalCases,
    ComponentIn: lazy(
      () => import("Components/kycAdminV2/ExceptionalCases/ExceptionalCases")
    )
  },
  {
    path: KycAdminPaths.kycMaintenance,
    ComponentIn: lazy(() => import("Components/KycAdmin/MaintenanceMode/MaintenanceBody"))
  },

  // Report Module
  {
    path: KycAdminPaths.declareReport,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Reports/DeclarationReport/DeclarationReport.js")
    )
  },
  {
    path: KycAdminPaths.kycDetailReport,
    ComponentIn: lazy(() => import("Components/KycAdmin/Reports/KYCDetails/KycDetailReport.js"))
  },
  {
    path: KycAdminPaths.kycNotOk,
    ComponentIn: lazy(() => import("Components/KycAdmin/Reports/KycNotOk/kycNotOk.js"))
  },
  {
    path: `${KycAdminPaths.currentBusiness}/:id?`,
    ComponentIn: lazy(() => import("Components/KycAdmin/Reports/CurrentBusiness/CurrentBusiness"))
  },
  {
    path: KycAdminPaths.kycFeedingReport,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Reports/KYCFeedingReport/KycFeedingReport.js")
    )
  },
  // {
  //   path: KycAdminPaths.diamondClubReport,
  //   ComponentIn: lazy(
  //     () => import("Components/KycAdmin/Reports/DiamondClubReport/DiamondClubReport.jsx")
  //   )
  // },
  {
    path: KycAdminPaths.selfPVReport,
    ComponentIn: lazy(() => import("Components/KycAdmin/Reports/SelfPVReport/SelfPVReport.jsx"))
  },
  {
    path: KycAdminPaths.diamondClubPurchaseReport,
    ComponentIn: lazy(
      () =>
        import(
          "Components/KycAdmin/Reports/DiamondClubPurchaseReport/DiamondClubPurchaseReport.jsx"
        )
    )
  },
  {
    path: KycAdminPaths.executiveFeedback_Report,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Reports/ExecutiveFeedbackReport/ExecutivesList.jsx")
    )
  },
  {
    path: KycAdminPaths.executiveFeedback_ReportData,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Reports/ExecutiveFeedbackReport/ExecutivesReportData.jsx")
    )
  },
  {
    path: KycAdminPaths.executiveFeedback_UserProfile,
    ComponentIn: lazy(
      () =>
        import(
          "Components/KycAdmin/Reports/ExecutiveFeedbackReport/ExecutivesReportUserProfile.jsx"
        )
    )
  },
  {
    path: KycAdminPaths.nonPurchasingABReport,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Reports/NonPurchasingABReport/NonPurchasingABReport.jsx")
    )
  },
  {
    path: KycAdminPaths.amountWiseABCountReport,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Reports/AmountWiseABCount/AmountWiseABCount.jsx")
    )
  },
  {
    path: KycAdminPaths.abLastSixMonthsPurchaseReport,
    ComponentIn: lazy(
      () =>
        import("Components/KycAdmin/Reports/AbLastSixMonthsReport/AbLastSixMonthsReportsOld.jsx")
    )
  },
  {
    path: KycAdminPaths.deathCaseReport,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Reports/AdminReports/DeathCase/DeathCaseReport.jsx")
    )
  },
  {
    path: KycAdminPaths.stopABReport,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Reports/AdminReports/StopABReport/StopABReport.jsx")
    )
  },
  {
    path: KycAdminPaths.allTermination,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Reports/AdminReports/AllTermination/AllTermination.jsx")
    )
  },
  {
    path: KycAdminPaths.redKycs,
    ComponentIn: lazy(() => import("Components/KycAdmin/Reports/RedKycs/RedKycs.jsx"))
  },
  {
    path: KycAdminPaths.abBulkDetailsReport,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Reports/AbBulkDetailsReport/AbBulkDetailsReport.jsx")
    )
  },
  {
    path: KycAdminPaths.pinGrowthAnalysis,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Reports/PinGrowthAnalysis/PinGrowthAnalysis.jsx")
    )
  },
  {
    path: KycAdminPaths.abCommission,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Reports/ABCommission/ABCommissionList")
    ) 
  },
  {
    path: KycAdminPaths.unethicalJoiningStop,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Reports/UnethicalJoiningStop/UnethicalJoiningStop.jsx")
    )
  },
  {
    path: KycAdminPaths.unethicalJoiningStopListing,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Reports/UnethicalJoiningStop/UnethicalJoiningStopListing.jsx")
    )
  },
  // Associate Buyer
  {
    path: KycAdminPaths.abIdStop,
    ComponentIn: lazy(() => import("Components/KycAdmin/AssociateBuyers/ABIDStop"))
  },
  {
    path: KycAdminPaths.resetpswrd,
    ComponentIn: lazy(() => import("Components/KycAdmin/AssociateBuyers/ABResetPassword"))
  },
  {
    path: KycAdminPaths.stopPayment,
    ComponentIn: lazy(() => import("Components/KycAdmin/AssociateBuyers/AbStopPayment"))
  },
  {
    path: KycAdminPaths.rePurchase,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/AssociateBuyers/ABRepurchaseSummaryDetails")
    )
  },
  {
    path: KycAdminPaths.abDetails,
    ComponentIn: lazy(() => import("Components/KycAdmin/AssociateBuyers/ABDetails/ABDetailsIndex"))
  },
  {
    path: KycAdminPaths.smsDiamondClub,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/AssociateBuyers/SmsDiamondClub/SmsDiamondClub")
    )
  },
  {
    path: KycAdminPaths.abNotPurchaseOtp,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/AssociateBuyers/ABNotPurchaseOtp/ABNotPurchaseOtp")
    )
  },
  {
    path: KycAdminPaths.abBankAccntUpdate,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/AssociateBuyers/ABBankAccountUpdate/ABBankAccountUpdate")
    )
  },
  {
    path: KycAdminPaths.abNameUpdate,
    ComponentIn: lazy(() => import("Components/KycAdmin/AssociateBuyers/ABNameUpdate/ABNameUpdate"))
  },
  {
    path: KycAdminPaths.updateMobileCount,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/AssociateBuyers/UpdateMobileCount/UpdateMobileCount")
    )
  },

  // List
  {
    path: KycAdminPaths.eKyc,
    ComponentIn: lazy(() => import("Components/KycAdmin/Lists/E-KYC/EKYC.js"))
  },
  {
    path: KycAdminPaths.monthlyMeetings,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Lists/DownloadMonthlyMeeting/MonthlyMeeting.js")
    )
  },
  {
    path: KycAdminPaths.terminateRepurchaseReport,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Lists/TerminateRepurchase/TerminateRepuchaseReport.js")
    )
  },
  {
    path: KycAdminPaths.abUptree,
    ComponentIn: lazy(() => import("Components/KycAdmin/AssociateBuyers/ABUptree"))
  },
  {
    path: KycAdminPaths.abPurchaseDownload,
    ComponentIn: lazy(() => import("Components/KycAdmin/AssociateBuyers/ABPurchaseDownload"))
  },
  {
    path: KycAdminPaths.technicalCore,
    ComponentIn: lazy(() => import("Components/KycAdmin/Lists/TechnicalCore/TechnicalCoreList.jsx"))
  },
  {
    path: KycAdminPaths.technicalLeaderTreeView,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Lists/TechnicalLeaderTreeView/TechnicalLeaderTreeView")
    )
  },
  {
    path: KycAdminPaths.pinAchieverReport,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Reports/PinAchieverReport/PinAchieverReport.jsx")
    )
  },
  {
    path: KycAdminPaths.pinDashboard,
    ComponentIn: lazy(() => import("Components/KycAdmin/Reports/PinDashboard/PinDashboard.jsx"))
  },

  // KYC
  {
    path: KycAdminPaths.kycSimilarEntities,
    ComponentIn: lazy(() => import("Components/KycAdmin/KYC/KycSimilarEntities/KycSimilarEntities"))
  },
  {
    path: KycAdminPaths.kycMatchingEntities,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/KYC/KycMatchingEntities/KycMatchingEntities")
    )
  },
  {
    path: KycAdminPaths.kycDocumentUpdate,
    ComponentIn: lazy(() => import("Components/KycAdmin/KYC/KycDocumentUpdate/KycDocumentUpdate"))
  },
  {
    path: KycAdminPaths.abPhotoUpdate,
    ComponentIn: lazy(() => import("Components/KycAdmin/KYC/AbPhotoUpdate/AbPhotoUpdate.jsx"))
  },
  {
    path: KycAdminPaths.kycNewEntry,
    ComponentIn: lazy(() => import("Components/KycAdmin/KYC/KycNewEntry/KycNewEntry.jsx"))
  },
  {
    path: KycAdminPaths.kycInstantApproval,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/KYC/KycInstantApproval/KycInstantApproval.jsx")
    )
  },
  {
    path: KycAdminPaths.kycOldEntry,
    ComponentIn: lazy(() => import("Components/KycAdmin/KYC/KycOldEntry/KycOldEntry.jsx"))
  },
  {
    path: KycAdminPaths.kycVerification,
    ComponentIn: lazy(() => import("Components/KycAdmin/KYC/Verification/Verification.jsx"))
  },

  // Document Update
  {
    path: KycAdminPaths.addPan,
    ComponentIn: lazy(() => import("Components/KycAdmin/DocumentUpdate/ABPanAdd"))
  },
  {
    path: KycAdminPaths.address_id_proof_update,
    ComponentIn: lazy(() => import("Components/KycAdmin/DocumentUpdate/AddressAndIDProofUpdate"))
  },

  // update request
  {
    path: KycAdminPaths.bankUpdateRequest,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/UpdateRequest/BankUpdateRequest/BankUpdateRequestList")
    )
  },
  {
    path: KycAdminPaths.viewBankUpdateRequest + "/:id",
    ComponentIn: lazy(
      () => import("Components/KycAdmin/UpdateRequest/BankUpdateRequest/ViewBankUpdateRequest")
    )
  },
  {
    path: KycAdminPaths.panUpdateRequest,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/UpdateRequest/PANUpdateRequest/PanUpdateRequest")
    )
  },
  {
    path: KycAdminPaths.viewPanUpdateRequest + "/:id",
    ComponentIn: lazy(
      () => import("Components/KycAdmin/UpdateRequest/PANUpdateRequest/ViewRequest")
    )
  },
  {
    path: KycAdminPaths.mobileUpdateRequest,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/UpdateRequest/MobileUpdateRequest/MobileUpdateRequestList")
    )
  },
  {
    path: KycAdminPaths.viewMobileUpdateRequest + "/:id",
    ComponentIn: lazy(
      () => import("Components/KycAdmin/UpdateRequest/MobileUpdateRequest/ViewMobileUpdateRequest")
    )
  },

  // Miscellanous
  {
    path: KycAdminPaths.abIdUnStop,
    ComponentIn: lazy(() => import("Components/KycAdmin/Miscellaneous/ABIDUnStop.jsx"))
  },
  {
    path: KycAdminPaths.deathCase,
    ComponentIn: lazy(() => import("Components/KycAdmin/Miscellaneous/DeathCase/DeathCase.jsx"))
  },
  // Assign KYC Lead
  {
    path: KycAdminPaths.assignKYCLead,
    ComponentIn: lazy(() => import("Components/KycAdmin/KYC/AssignKYCLead/AssignKYCLead"))
  },
  {
    path: KycAdminPaths.bankAccount,
    ComponentIn: lazy(() => import("Components/KycAdmin/DeleteABDetails/BankAccount"))
  },
  {
    path: KycAdminPaths.bulkBankAccountEnable,
    ComponentIn: lazy(() => import("Components/KycAdmin/DeleteABDetails/BulkBankAccountEnable"))
  },
  {
    path: KycAdminPaths.panNo,
    ComponentIn: lazy(() => import("Components/KycAdmin/DeleteABDetails/PanNumber"))
  },
  {
    path: KycAdminPaths.bulkPanNumberEnable,
    ComponentIn: lazy(() => import("Components/KycAdmin/DeleteABDetails/BulkPanNoEnable"))
  },
  {
    path: KycAdminPaths.notOkReport,
    ComponentIn: lazy(() => import("Components/KycAdmin/Mis/NotOkReport/NotOkReport"))
  },
  {
    path: KycAdminPaths.executivePerformanceReport,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Mis/ExecutivePerformanceReport/ExecutivePerformanceReport")
    )
  },
  {
    path: KycAdminPaths.executiveCheckReport,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Mis/ExecutiveCheckReport/ExecutiveCheckReport")
    )
  },
  {
    path: KycAdminPaths.dailyUpdateSummaryReport,
    ComponentIn: lazy(() => import("Components/KycAdmin/Mis/DailyUpdateSummary/DailyUpdateSummary"))
  },
  {
    path: KycAdminPaths.declarationCheckReport,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Mis/DeclarationCheckReport/DeclarationCheckReport")
    )
  },
  {
    path: KycAdminPaths.bankAndPanReport,
    ComponentIn: lazy(() => import("Components/KycAdmin/Mis/BankPanReport/BankPanReport"))
  },
  // {
  //   path: KycAdminPaths.emailCheckReport,
  //   ComponentIn: lazy(() => import("Components/KycAdmin/Mis/EmailReport/EmailReport"))
  // },
  {
    path: KycAdminPaths.mobileCheckReport,
    ComponentIn: lazy(() => import("Components/KycAdmin/Mis/MobileReport/MobileReport"))
  },
  {
    path: KycAdminPaths.idProofCheckReport,
    ComponentIn: lazy(() => import("Components/KycAdmin/Mis/IdProofReport/IdProofReport"))
  },
  {
    path: KycAdminPaths.nameUpdateCheckReport,
    ComponentIn: lazy(() => import("Components/KycAdmin/Mis/NameReport/NameReport"))
  },
  {
    path: KycAdminPaths.infoUpdateCheckReport,
    ComponentIn: lazy(() => import("Components/KycAdmin/Mis/InfoReport/InfoReport"))
  },

  {
    path: KycAdminPaths.updateGst,
    ComponentIn: lazy(() => import("Components/Admin/KycAdmin/UpdateGstIndex"))
  },
  {
    path: KycAdminPaths.gst,
    ComponentIn: lazy(() => import("Components/Admin/KycAdmin/GstListing"))
  },
  {
    path: KycAdminPaths.stopTerminationReport,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Reports/StopTerminationReport/StopTerminationReport")
    )
  },
  {
    path: KycAdminPaths.masterAbDetails,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/KycTracks/MasterAbDetails/MasterABDetailsIndex")
    )
  },
  {
    path: KycAdminPaths.imageHistory,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/KycHistory/ImageHistory/ImageHistory")
    )
  },
  {
    path: KycAdminPaths.rbRepurchase,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Miscellaneous/RBRepurchase/RBRepurchaseSummaryDetails")
    )
  },
  {
    path: KycAdminPaths.nbRepurchase,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Miscellaneous/NBRepurchase/NBRepurchaseSummaryDetails")
    )
  },
  {
    path: KycAdminPaths.inactiveRegisteredBuyer,
    ComponentIn: lazy(
      () =>
        import(
          "Components/KycAdmin/Miscellaneous/InactiveRegisteredBuyer/InactiveRegisteredBuyer"
        )
    )
  },
  {
    path: KycAdminPaths.masterPinDescription,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Masters/MasterPinDescription/MasterPinDescription")
    )
  },
  {
    path: KycAdminPaths.masterDocuments,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Masters/MasterDocuments/MasterDocuments")
    )
  },
  {
    path: KycAdminPaths.masterOccupations,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Masters/MasterOccupations/MasterOccupations")
    )
  },
  {
    path: KycAdminPaths.masterRelations,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Masters/MasterRelations/MasterRelations")
    )
  },
  {
    path: KycAdminPaths.masterDiamondClub,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Masters/MasterDiamondClub/MasterDiamondClub")
    )
  },
  {
    path: KycAdminPaths.masterCompanyList,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Masters/MasterCompanyList/MasterCompanyList")
    )
  },
  {
    path: KycAdminPaths.masterKycReasonDesc,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Masters/MasterKycReasonDesc/MasterKycReasonDesc")
    )
  },
  {
    path: KycAdminPaths.masterDepartmentList,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Masters/MasterDepartmentList/MasterDepartmentList")
    )
  },
  {
    path: KycAdminPaths.kycAccountsBusinessPayment,
    ComponentIn: lazy(
      () => import("Components/KycAdmin/Accounts/BusinessPayment/BusinessEntry.jsx")
    )
  },
  {
    path: KycAdminPaths.kycAccountsPayment,
    ComponentIn: lazy(() => import("Components/KycAdmin/Accounts/Payment/PaymentEntry.jsx"))
  },
  {
    path: KycAdminPaths.kycAccountsJv,
    ComponentIn: lazy(() => import("Components/KycAdmin/Accounts/JvVoucher/JvEntry.jsx"))
  }
];
